// src/components/User/Header.jsx
import React, { useState, useContext } from 'react';
import { Link, useLocation, matchPath } from 'react-router-dom';
import { AppContext } from './AppContext';

export default function Header() {
    const { settings, projectHighlights } = useContext(AppContext);
    const { whatsapp_default_message = '', phone_link = '' } = settings || {};

    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);

    // Determine WhatsApp message: default, or if on a project detail page, include project name
    let whatsappMessage = whatsapp_default_message;
    const match = matchPath('/project/:slug', location.pathname);
    if (match && projectHighlights?.projectHighlights) {
        const { slug } = match.params;
        const project = projectHighlights.projectHighlights.find(p => p.slug === slug);
        if (project?.name) {
            whatsappMessage = `Hello, I'm interested in ${project.name}.`;
        }
    }
    const whatsappUrl = `https://wa.me/${phone_link}?text=${encodeURIComponent(whatsappMessage)}`;

    // inside Header.jsx, above your return
    const raw = phone_link || '';
    const parts = raw.match(/^(\d{2})(\d{5})(\d{5})$/);
    const formattedPhone = parts
        ? `+${parts[1]} ${parts[2]} ${parts[3]}`
        : raw;

    return (
        <>
            {/* Floating WhatsApp button */}
            <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 bg-green-500 w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                    alt="WhatsApp"
                    className="w-12 h-12"
                />
            </a>

            <header className="bg-yellow-400 shadow-md py-2 px-2 sticky top-0 z-50 w-full">
                <div className="container mx-auto px-4 flex items-center justify-between">
                    {/* Logo */}
                    <Link to="/" className="flex items-center">
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/images/Propxplorer_transparent.png`}
                            alt="PropXplorer Logo"
                            className="h-8 w-auto"
                        />
                    </Link>

                    {/* Desktop Nav */}
                    <nav className="hidden md:flex items-center gap-6">
                        <Link to="/" className="text-gray-800 hover:font-semibold transition">Home</Link>
                        <Link to="/developers" className="text-gray-800 hover:font-semibold transition">Developers</Link>
                        <a
                            href={whatsappUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-black text-yellow-400 border border-2 border-black transition hover:text-black hover:bg-yellow-400 hover:font-semibold py-2 px-3 rounded"
                        >
                            {formattedPhone}
                        </a>
                    </nav>

                    {/* Mobile Menu Button */}
                    <button
                        className="md:hidden bg-transparent text-gray-800 focus:outline-none focus:ring-0"
                        onClick={() => setMenuOpen(o => !o)}
                    >
                        <i className={`fa-solid ${menuOpen ? 'fa-xmark' : 'fa-bars'} text-2xl`} />
                    </button>

                </div>

                {/* Mobile Dropdown */}
                {menuOpen && (
                    <div className="md:hidden bg-yellow-400 py-2">
                        <Link to="/" className="block text-gray-800 transition hover:font-semibold mx-4 py-4">Home</Link>
                        <Link to="/developers" className="block text-gray-800 transition hover:font-semibold mx-4 py-4">Developers</Link>
                        <a
                            href={`tel:+${phone_link}`}
                            className="block mx-4 mt-4 bg-black text-yellow-400 border border-2 border-black hover:text-black hover:bg-yellow-400 hover:font-semibold py-2 px-3 rounded text-center"
                        >
                            {formattedPhone}
                        </a>
                    </div>
                )}
            </header >
        </>
    );
}
